// extracted by mini-css-extract-plugin
export default {"yearTableContainer":"GlobalnaTabela_yearTableContainer__IXb0D","spinner":"GlobalnaTabela_spinner__9JLv+"};